import React, { Component } from "react";
import PropType from "prop-types";

import "./Footer.style.scss";

import Assets from "../../assetIndex";

/*
 * `isCsOpen` tidak diimpor lagi: titik status di depan jam sudah dibuang, dan
 * footer tidak lagi mengaku tahu apakah CS sedang online. Fungsinya tetap
 * tinggal di constants.js, sama seperti `getCsStatus` di hanamaru.
 */
import { CS_HOURS, PAYMENTS, SOCIALS, STORES } from "./constants";
import { CS_EMAIL, getCsWhatsAppUrl } from "../../lib/contact";

/**
 * Logo WhatsApp versi padat, bukan versi garis. Cermin dari `WhatsAppIcon` di
 * hanamaru.
 *
 * `icon/whatsapp.svg` memakai logo versi garis di dalam kotak oranye: pada
 * 14-16px garis-garisnya menyatu jadi satu bercak dan tidak ada yang
 * mengenalinya sebagai WhatsApp. Siluet padat tetap terbaca di ukuran segitu
 * karena yang dikenali bentuk luarnya.
 *
 * Diwarnai `currentColor` dan dirender inline, bukan lewat `<img>`, supaya
 * ikutan berubah warna bersama tombolnya.
 */
function WhatsAppIcon({ size }) {
  return (
    <svg width={size || 15} height={size || 15} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12.001 2C17.524 2 22.001 6.477 22.001 12C22.001 17.523 17.524 22 12.001 22C10.2338 22.003 8.49758 21.5353 6.971 20.645L2.005 22L3.357 17.032C2.46596 15.5049 1.9979 13.768 2.001 12C2.001 6.477 6.478 2 12.001 2ZM8.593 7.3L8.393 7.308C8.26369 7.31691 8.13735 7.35087 8.021 7.408C7.91257 7.46951 7.81356 7.5463 7.727 7.636C7.607 7.749 7.539 7.847 7.466 7.942C7.09612 8.4229 6.89697 9.01331 6.9 9.62C6.902 10.11 7.03 10.587 7.23 11.033C7.639 11.935 8.312 12.89 9.2 13.775C9.414 13.988 9.624 14.202 9.85 14.401C10.9534 15.3724 12.2683 16.073 13.69 16.447L14.258 16.534C14.443 16.544 14.628 16.53 14.814 16.521C15.1052 16.5056 15.3895 16.4268 15.647 16.29C15.7778 16.2223 15.9056 16.1489 16.03 16.07C16.03 16.07 16.0723 16.0413 16.155 15.98C16.29 15.88 16.373 15.809 16.485 15.692C16.569 15.6053 16.639 15.5047 16.695 15.39C16.773 15.227 16.851 14.916 16.883 14.657C16.907 14.459 16.9 14.351 16.897 14.284C16.893 14.177 16.804 14.066 16.707 14.019L16.125 13.758C16.125 13.758 15.255 13.379 14.723 13.137C14.6673 13.1128 14.6077 13.0989 14.547 13.096C14.4786 13.0888 14.4094 13.0965 14.3442 13.1184C14.279 13.1403 14.2192 13.176 14.169 13.223C14.164 13.221 14.097 13.278 13.374 14.154C13.3325 14.2098 13.2753 14.2519 13.2098 14.2751C13.1443 14.2982 13.0733 14.3013 13.006 14.284C12.9408 14.2666 12.877 14.2446 12.815 14.218C12.691 14.166 12.648 14.146 12.563 14.11C11.9889 13.8599 11.4574 13.5215 10.988 13.107C10.862 12.997 10.745 12.877 10.625 12.761C10.2316 12.3842 9.88875 11.958 9.605 11.493L9.546 11.398C9.50426 11.3338 9.47004 11.265 9.444 11.193C9.406 11.046 9.505 10.928 9.505 10.928C9.505 10.928 9.748 10.662 9.861 10.518C9.971 10.378 10.064 10.242 10.124 10.145C10.242 9.955 10.279 9.76 10.217 9.609C9.937 8.925 9.64767 8.24467 9.349 7.568C9.29 7.434 9.115 7.338 8.956 7.319C8.902 7.31233 8.848 7.307 8.794 7.303C8.65973 7.2953 8.52509 7.29663 8.391 7.307L8.593 7.3Z" />
    </svg>
  );
}

WhatsAppIcon.propTypes = {
  size: PropType.number
};

WhatsAppIcon.defaultProps = {
  size: 15
};

function TicketIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1.2a2.8 2.8 0 0 0 0 5.6V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-1.2a2.8 2.8 0 0 0 0-5.6V8Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path d="M14 6v12" stroke="currentColor" strokeWidth="1.8" strokeDasharray="2 2.4" strokeLinecap="round" />
    </svg>
  );
}

function PaletteIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 3.5a8.5 8.5 0 0 0 0 17c1.2 0 1.9-.8 1.9-1.7 0-.5-.2-.9-.5-1.2-.3-.3-.5-.7-.5-1.2 0-.9.8-1.6 1.7-1.6h1.6a4.3 4.3 0 0 0 4.3-4.3c0-4-3.8-7-8.5-7Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <circle cx="7.8" cy="11.6" r="1.15" fill="currentColor" />
      <circle cx="10.4" cy="7.9" r="1.15" fill="currentColor" />
      <circle cx="14.8" cy="7.6" r="1.15" fill="currentColor" />
    </svg>
  );
}

function HelpIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
      <path
        d="M9.4 9.3a2.7 2.7 0 0 1 5.2.9c0 1.8-2.6 2.2-2.6 3.9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="12" cy="17.2" r="1.2" fill="currentColor" />
    </svg>
  );
}

/**
 * Lencana Cosplay Corner: gantungan baju.
 *
 * Toko itu satu-satunya yang tidak punya huruf Yunani, dan yang dijual di sana
 * kostum -- jadi bentuknya, bukan inisial. Digambar dengan garis supaya
 * setebal huruf di lencana tetangganya pada 24px. Cermin dari `HangerIcon` di
 * `components/Footer/index.tsx` milik hanamaru.
 */
function HangerIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="13"
      height="13"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 10V8.4a2.2 2.2 0 1 1 2.2-2.2" />
      <path d="m12 10-7.9 5.2a1.3 1.3 0 0 0 .7 2.4h14.4a1.3 1.3 0 0 0 .7-2.4L12 10Z" />
    </svg>
  );
}

/**
 * Kartu besar untuk Events dan Kyou Artist.
 *
 * Keduanya sengaja TIDAK jadi satu baris di kolom tautan: keduanya tujuan yang
 * jarang dicari orang lewat footer tapi selalu senang ditemukan, jadi mereka
 * dapat bobot visual, bukan baris kedua belas. Tempatnya di bawah kartu toko
 * fisik, karena ketiganya menjawab pertanyaan yang sama: Kyou bisa didatangi
 * di mana.
 */
function FeatureCard({ href, eyebrow, title, blurb, cta, icon }) {
  return (
    <a href={href} target="_blank" rel="noreferrer noopener" className="footer__card">
      <span className="footer__card-icon">{icon}</span>
      <span className="footer__card-body">
        <span className="footer__card-eyebrow">{eyebrow}</span>
        <span className="footer__card-title">{title}</span>
        <span className="footer__card-blurb">{blurb}</span>
      </span>
      <span className="footer__card-cta">{cta} &rarr;</span>
    </a>
  );
}

FeatureCard.propTypes = {
  href: PropType.string.isRequired,
  eyebrow: PropType.string.isRequired,
  title: PropType.string.isRequired,
  blurb: PropType.string.isRequired,
  cta: PropType.string.isRequired,
  icon: PropType.node.isRequired
};

export default class Footer extends Component {
  static propTypes = {
    className: PropType.string
  };

  static defaultProps = {
    className: ""
  };

  /*
   * Status CS dihitung SETELAH mount, tidak pernah saat render pertama, supaya
   * halaman yang tersaji dari cache tidak membekukan titik hijaunya. Sampai
   * efek ini jalan, titiknya abu-abu; jam operasional di sebelahnya tetap
   * kalimat yang benar kapan pun.
   */
  render() {
    const { className } = this.props;

    return (
      <footer className={className}>
        <div className="footer__inner">
          {/*
            Lima kolom sebaris: empat kolom tautan, lalu kotak Customer Service.
            Legal dapat porsi terlebar karena Return & Refund Policy membawa
            sub-daftar, dan kotak CS punya lantai lebar supaya barisan sosialnya
            tidak pernah patah jadi dua baris.
          */}
          <div className="footer__cols">
            <div className="footer__col">
              <h4 className="footer__heading">Stores</h4>
              <ul className="footer__list">
                {STORES.map(store => (
                  <li key={store.href}>
                    <a href={store.href} target="_blank" rel="noreferrer noopener" className="footer__link">
                      {store.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer__col">
              <h4 className="footer__heading">Services</h4>
              <ul className="footer__list">
                <li>
                  <a href="https://oripa.kyou.id" target="_blank" rel="noreferrer noopener" className="footer__link">
                    Oripa
                  </a>
                </li>
                <li>
                  <a href="/unique-request" className="footer__link">
                    Unique Request
                  </a>
                </li>
                <li>
                  <a href="/friendship-points" className="footer__link">
                    Friendship Points
                  </a>
                </li>
                <li>
                  <a href="https://partner.kyou.id" target="_blank" rel="noreferrer noopener" className="footer__link">
                    Partner Area (B2B)
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer__col">
              <h4 className="footer__heading">Legal</h4>
              <ul className="footer__list">
                <li>
                  <a href="/terms-and-conditions" className="footer__link">
                    Terms and Conditions
                  </a>
                </li>
                <li>
                  <a href="/privacy-policy" className="footer__link">
                    Privacy Policy
                  </a>
                </li>
                {/*
                  Tetap dua tautan terpisah, karena kedua kebijakan punya batas
                  waktu klaim yang berbeda -- 14 hari untuk Ready Stock &
                  Pre-Order, 3 hari untuk Unique Request -- dan satu pintu masuk
                  bersama membuat pembaca menebak mana yang berlaku untuknya.
                  "Return & Refund Policy" di atasnya BUKAN tautan: halaman
                  pemilihnya sudah dihapus di hanamaru, jadi ia cuma label
                  kelompok.
                */}
                <li>
                  <span className="footer__group">Return &amp; Refund Policy</span>
                  <ul className="footer__sublist">
                    <li>
                      <a href="/return-refund-policy/ready-stock-and-pre-order" className="footer__link">
                        Ready Stock &amp; Pre-Order
                      </a>
                    </li>
                    <li>
                      <a href="/return-refund-policy/unique-request" className="footer__link">
                        Unique Request
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>

            <div className="footer__col">
              <h4 className="footer__heading">Metode Pembayaran</h4>
              {/*
                Logo-logo ini berwarna dan dibuat untuk latar terang, jadi tiap
                satunya duduk di atas keping putih sendiri. Tanpa itu logo
                bertinta gelap (BCA, Mandiri) hilang di ground cokelat.
              */}
              <ul className="footer__payments">
                {PAYMENTS.map(payment => (
                  <li key={payment.alt} title={payment.title}>
                    {payment.href ? (
                      <a href={payment.href} target="_blank" rel="noreferrer noopener">
                        <img src={payment.src} alt={payment.alt} loading="lazy" decoding="async" />
                      </a>
                    ) : (
                      <img src={payment.src} alt={payment.alt} loading="lazy" decoding="async" />
                    )}
                  </li>
                ))}
              </ul>
            </div>

            {/*
              Kolom ini berdiri sendiri sebagai kotak karena isinya bukan daftar
              tautan seperti empat kolom di sebelahnya, melainkan satu pertanyaan
              yang dijawab berurutan: coba jawab sendiri dulu, ini keadaan CS
              sekarang, dan ini kanal-kanalnya beserta gunanya masing-masing.
            */}
            <div className="footer__cs">
              <h4 className="footer__heading">Interact with Kyou</h4>

              {/*
                Satu-satunya elemen bergaya tombol di kotak ini. Help Center
                menjawab hampir semua pertanyaan yang membawa orang ke sini, dan
                menjawabnya tanpa antre, jadi ia berhak terlihat lebih dulu
                daripada kanal mana pun yang menunggu balasan manusia.
              */}
              <a href="/help" target="_blank" rel="noreferrer noopener" className="footer__cs-cta">
                <HelpIcon />
                Help Center (FAQ)
              </a>

              {/*
                Jam operasional duduk tepat di atas tombol WhatsApp karena itu
                keterangan tombol itu: jam berapa chat ini dijawab.

                Titik statusnya dibuang. Hijau/abu-abu di depan jam membuat
                baris ini mengaku tahu apakah CS sedang online, padahal yang
                tertulis cuma jadwal -- dan titik itu baru benar setelah efek
                klien jalan, jadi pembaca pertama selalu melihat abu-abu.
              */}
              <p className="footer__cs-hours">{CS_HOURS}</p>

              {/*
                Tombol WhatsApp hijau, meniru tombol CS di Oripa
                (`site-footer-wabtn`). Tempatnya dulu diisi baris
                "0817 7009 2014" berikon gagang telepon yang -- meski selalu
                menaut ke WhatsApp -- terbaca sebagai nomor yang akan
                ditelepon.

                Nomornya sendiri tidak ikut dicetak. Nomor WhatsApp tertulis
                cuma mengundang orang menyalinnya ke aplikasi lain, padahal
                tombol ini sudah membuka percakapan yang benar lengkap dengan
                sapaannya.
              */}
              <a
                href={getCsWhatsAppUrl()}
                target="_blank"
                rel="noreferrer noopener"
                title="Chat WA Kyou (Online Service)"
                className="footer__cs-wabtn"
              >
                <WhatsAppIcon size={16} />
                Chat WA Online Service
              </a>

              {/*
                E-mail jadi tombol juga, supaya panel ini menawarkan tiga pintu
                dengan bentuk yang sama, bukan dua tombol dan satu tautan
                nyasar. Warnanya sengaja redup: oranye dan hijau sudah memegang
                dua kanal yang paling dicari orang, dan tombol terang ketiga
                bikin ketiganya terbaca sama mendesaknya.
              */}
              <a href={`mailto:${CS_EMAIL}`} title="Email Kyou" className="footer__cs-mailbtn">
                <img src={Assets.Mail} alt="" loading="lazy" decoding="async" />
                {CS_EMAIL}
              </a>

              {/*
                Keping bulat seukuran sentuhan, seperti barisan sosial di
                footer email. WhatsApp sudah tidak ada di barisan ini: logonya
                16px di dalam keping terbaca sebagai bercak oranye dan tidak
                ada yang mengenalinya, dan tujuannya pun sama persis dengan
                tombol hijau di atas. Satu kanal, satu tombol.
              */}
              <ul className="footer__socials">
                {SOCIALS.map(social => (
                  <li key={social.href}>
                    <a href={social.href} target="_blank" rel="noreferrer noopener" title={social.label}>
                      <img src={social.src} alt={social.label} loading="lazy" decoding="async" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="footer__rule" />

          {/*
            Blok toko fisik. Dulu isinya ditulis dua kali -- satu cabang mobile
            di dalam kolom kontak, satu cabang desktop di bawah -- dan yang
            memilih di antaranya `window.innerWidth`. Sekarang satu daftar dari
            constants.js yang dirender sekali, dan yang berubah cuma jumlah
            kolomnya.
          */}
          <h4 className="footer__stores-title">
            Mampir ke toko fisik Kyou di Bekasi, Tangerang, Surabaya, dan Bandung!
          </h4>

          <div className="footer__stores">
            {STORES.map(store => (
              /* Delta tidak punya halaman sendiri, jadi `href`-nya null dan
                 tidak bisa dipakai sebagai key. */
              <div key={store.name} className="footer__store">
                {/*
                  Cosplay Corner tidak punya huruf Yunani; sejak 6 Okt 2026 ia
                  memakai gantungan baju, jadi kelima kartu punya lencana dan
                  namanya rata kiri. Yang sama sekali tanpa lencana tetap tidak
                  merender kotaknya -- menyisakan tempat kosong membuat namanya
                  tergeser sementara kota dan alamat di bawahnya rata kiri.
                */}
                <div className="footer__store-head">
                  {store.sigil || store.sigilIcon ? (
                    <span className="footer__sigil" style={{ fontFamily: store.sigilFont }}>
                      {store.sigilIcon === "hanger" ? <HangerIcon /> : store.sigil}
                    </span>
                  ) : null}

                  {/* Nama toko tanpa halaman sendiri TIDAK ditautkan: alamat di
                      bawahnya sudah menuju peta yang sama. */}
                  {store.href ? (
                    <a href={store.href} target="_blank" rel="noreferrer noopener" className="footer__store-name">
                      {store.name}
                    </a>
                  ) : (
                    <span className="footer__store-name footer__store-name--plain">{store.name}</span>
                  )}

                </div>

                <span className="footer__store-city">{store.city}</span>

                <a
                  href={store.mapsUrl}
                  target="_blank"
                  rel="noreferrer noopener"
                  title={`Buka ${store.name} di peta`}
                  className="footer__store-address"
                >
                  {store.address}
                </a>

                {/*
                  Nomor toko dulu menaut ke Google Maps, bukan ke nomornya
                  sendiri -- menekan "Phone: (021) 88898362" di ponsel membuka
                  peta.

                  Yang tercetak di sini sekarang HANYA telepon. Nomor WhatsApp
                  tidak lagi ditulis sebagai angka: ia punya tombol hijau di
                  bawah, dan satu nomor tercetak yang ternyata membuka WhatsApp
                  justru membuat pembaca menebak ke mana baris itu membawanya.

                  Jaraknya rapat ke alamat dan ruang kosong kartu jatuh di
                  bawahnya: telepon dan alamat adalah satu hal yang sama, yaitu
                  cara menemui toko ini.
                */}
                {store.phoneHref && store.phoneLabel ? (
                  <a href={store.phoneHref} title={`Telepon ${store.name}`} className="footer__store-phone">
                    {store.phoneLabel}
                  </a>
                ) : null}

                {/* Ruang kosong kartu, supaya tombol WhatsApp-nya rata bawah. */}
                <div className="footer__store-spacer" aria-hidden="true" />

                {/*
                  Tinggal WhatsApp di sini, selebar kartu. Labelnya menyebut
                  tokonya, bukan cuma aplikasinya: ada lima tombol seperti ini
                  di footer dan semuanya membuka WhatsApp, jadi yang
                  membedakan adalah siapa yang mengangkat.

                  Berhenti di nama toko. "Chat WA Kyou (Cosplay Corner)" butuh
                  172px sementara tombol ini paling lebar 169px, jadi kalau
                  ditulis utuh ia melipat dan tombolnya membengkak. Frasa
                  lengkapnya hidup di `title`.
                */}
                {store.whatsappHref ? (
                  <a
                    href={store.whatsappHref}
                    target="_blank"
                    rel="noreferrer noopener"
                    title={`Chat WA Kyou (${store.name})`}
                    className="footer__store-wabtn"
                  >
                    <WhatsAppIcon size={14} />
                    {`Chat WA ${store.name}`}
                  </a>
                ) : null}

                {/*
                  Tour 360° duduk di bawah tombol WhatsApp, sama-sama selebar
                  kartu. Berdampingan keduanya harus berbagi ~190px, yang
                  memaksa labelnya dipendekkan jadi "360°" dan "Chat WA" dan
                  tetap melipat dua baris di kolom kelima pada 1280px.
                  Bertumpuk, masing-masing dapat lebar penuh.

                  WhatsApp di atas karena itu yang dicari orang waktu membuka
                  kartu toko; tour-nya pelengkap di bawahnya.
                */}
                {store.tourUrl ? (
                  <a
                    href={store.tourUrl}
                    target="_blank"
                    rel="noreferrer noopener"
                    title={`Tour 360° ${store.name}`}
                    className="footer__store-tour"
                  >
                    <img src={Assets.Tour360} alt="" loading="lazy" decoding="async" />
                    360° View
                  </a>
                ) : null}

              </div>
            ))}
          </div>

          {/*
            Events dan Kyou Artist duduk sebagai baris terakhir blok toko,
            dengan jarak yang sama dengan jarak antar kartu toko di atasnya --
            jadi keduanya terbaca sebagai lanjutan daftar "tempat yang bisa
            didatangi", bukan spanduk sendiri di pucuk footer.
          */}
          <div className="footer__cards">
            <FeatureCard
              href="/events"
              eyebrow="Lagi ada apa di Kyou?"
              title="Events Kyou"
              blurb="Booth, pop-up store, dan event Kyou yang bakal datang. Intip juga arsip event yang sudah lewat."
              cta="Lihat"
              icon={<TicketIcon />}
            />
            <FeatureCard
              href="https://artist.kyou.id"
              eyebrow="Kenalan dulu yuk!"
              title="Kyou Artist"
              blurb="Kenalan dengan 12 kreator lokal yang mengisi Kyou dengan ilustrasi tematik setiap bulan."
              cta="Mampir"
              icon={<PaletteIcon />}
            />
          </div>

          <div className="footer__rule" />

          <div className="footer__copyright">
            <picture>
              <source srcSet={`${Assets.KyouLogo}.webp`} type="image/webp" />
              <source srcSet={Assets.KyouLogo} type="image/png" />
              <img src={Assets.KyouLogo} alt="logo kyou" loading="lazy" decoding="async" />
            </picture>
            <span className="footer__tagline">Ayo #RayakanHobimu bareng Kyou!</span>
            <span className="footer__copy">
              {`© 2014-${new Date().getFullYear()} Kyou Hobby Shop`}
            </span>
          </div>
        </div>
      </footer>
    );
  }
}
